/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/zeropaymentreport.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_ZERO_PAYMENT_USERS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetZeroPaymentUsersMethods extends IPluginMethodMap {
  getZeroPaymentUsers(args: any): Promise<any>;
}

export class GetZeroPaymentUsersService implements IAgentPlugin {
  readonly methods: IGetZeroPaymentUsersMethods;

  constructor() {
    this.methods = {
      getZeroPaymentUsers: this.getZeroPaymentUsers.bind(this),
    };
  }

  async getZeroPaymentUsers(args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log("args in zero payment service====", pretty(args));
    let filer_apply = args?.criteria ? args?.criteria : {};
    console.log("filet apply====", filer_apply);
    let presentationOptions: any = [],
      defaultPresentation: any = "";

    filer_apply = this.convertCriteria(args?.criteria);
    let variables = {
      options: {
        limit: args?.size ?? 10,
        skip: args?.offset ?? 0,
        sort: {
          field: "createdAt",
          order: "desc",
        },
      },
      filter: {
        paymentStats: {
          eq: "UnPaid",
        },
        ...filer_apply,
      },
    };
    console.log("filter in zero payment user", variables);
    const _filter = {
      // status: {
      //   eq: "active",
      // },
      // year: {
      //   eq: "2024",
      // },
    };
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: 10,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (
          presentation &&
          presentation?.data?.getPresentations?.content[0]?.id
        ) {
          defaultPresentation =
            presentation?.data?.getPresentations?.content[0]?.id;
          presentationOptions =
            presentation?.data?.getPresentations?.content?.map((_item: any) => {
              return { value: _item?.id, label: _item?.name };
            });
          variables.filter.presentation = {
            eq: args?.criteria?.presentation ?? defaultPresentation,
          };
        }
        const res = await client.query({
          query: GET_ZERO_PAYMENT_USERS,
          variables: variables,
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(
            res?.data?.getUserAdvancedSearch?.content
          );

          let _totalPages = res?.data?.getUserAdvancedSearch?.count
            ? Math.ceil(parseInt(res?.data?.getUserAdvancedSearch?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getUserAdvancedSearch?.skip /
            res?.data?.getUserAdvancedSearch?.limit +
            1;
          console.log("_rowData==>", _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getUserAdvancedSearch?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getUserAdvancedSearch?.count,
            totalPages: _totalPages,
            searchPresentationFilter: presentationOptions,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (key != "presentation") result[key] = { contains: criteria[key] };
    }
    return result;
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    let totalPaid = users.length > 0 ? 0 : "";
    users &&
      users.forEach((data?: any) => {
        _rowData.push({
          id: data?._id,
          name: data?.User?.fullName ?? "Null Null",
          email: data?.User?.email ?? "-",
          Committee:
            data?.ReferalUsers.length > 0
              ? data?.ReferalUsers[0]?.fullName
              : "-",
          dateCreated: moment(data?.createdAt).format("L"),
          costumeCost: data?.totalAmount ?? 0,
          TypeName: data?.CostumeType?.name ?? "-",
          SectionName: data?.Section?.name ?? "-",
          totalpaidTTd: totalPaid ?? 0,
          userId: data?.User?._id ?? "-"
        });
        // }
      });
    return _rowData;
  }
}
